// Mq
export const large = "screen and (min-width: 64em)"
export const medium = "screen and (min-width: 42em) and (max-width: 64em)"
export const small = "screen and (max-width: 42em)"

export const borderColor = "#dce6f0"
export const mainColor = "#2c3e50"
